export const ZOOM_MULTIPLIER = 0.05

export const POINTER_MULTIPLIER = 0.88

// "Strips" mode (OCT-5072): below this scale block content is a few pixels tall, so #tree
// gets STRIPS_CLASS and blocks are painted as plain colour strips without their content
// (see buildCanvasEvent and Block.module.scss).
export const STRIPS_SCALE = 0.2
export const STRIPS_CLASS = '--strips'

// Put on #printed-node while the PNG export captures the artboard (OCT-5237). html2canvas
// copies the computed styles of every SVG node into inline styles while it clones the
// document — before onclone runs — so a wireframe inside a card that off-screen culling or
// strips mode has hidden stays hidden in the PNG no matter what onclone adds. The marker
// therefore has to lift both on the live DOM, before the capture starts.
export const CAPTURE_CLASS = '--capture'
